export default "__VITE_ASSET__CjVSE3BN__"